<!-- 调拨入库记账 -->
<template>
    <div class='page_content'>
        <!-- 记账打印 -->
        <orderKeepPrint ref="orderKeepPrint"></orderKeepPrint>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <storeOutQueryRcAciton v-if="showStatus" ref="storeOutQueryRcAciton" @drawerCancel="drawerCancel"
                @toDetail="toDetail" :actionData="actionData">
            </storeOutQueryRcAciton>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
                @openFormDesign="openFormDesign"></v-button> 
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform"
                    :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">

                </v-search>

            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" size="mini" stripe :data="returnData.list" :height="tableHeight"
                :key="$store.state.tableNum" border style="width: 100%" @selection-change="handleSelectionChange"
                highlight-current-row>
                <el-table-column type="selection" align="center" width="55">
                </el-table-column>
                <el-table-column align="center" v-if="tableValye.isShow == 1"
                    v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
                    show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField"
                    :label="tableValye.showField">
                    <template slot-scope="scope">
                        <span v-if="tableValye.entityField == 'psomState'">
                            {{ $store.state.purchaseOrderState[scope.row[tableValye.entityField]].name }}
                        </span>
                        <!-- <span v-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{$common.getLocalTime(scope.row[tableValye.entityField])}}
              </span>
            </span> -->
                        <span v-else-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                        <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                        </span>
                        <span v-else-if="tableValye.entityField == 'rcState'">
                            <el-tag size="mini">{{ getStatusName(scope.row.rmToState) }}</el-tag>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                        </span>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "@/byComponents/SearchScheme.vue";
import ExtractionScheme from "@/byComponents/ExtractionScheme.vue";
import orderKeepPrint from "@/components/orderKeepPrint.vue";
import storeOutQueryRcAciton from "@/components/storeOutQueryRcAciton.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
        orderKeepPrint,
        storeOutQueryRcAciton,

    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                businessId: "",
                ormId: '',
                rmoutBkeId: '',
                page: 1,
                rows: 30,
                start:
                    new Date(new Date().toLocaleDateString()).getTime() -
                    31 * 24 * 3600 * 1000,
                end:
                    new Date(new Date().toLocaleDateString()).getTime() +
                    24 * 60 * 60 * 1000 -
                    1,
                storeId: ''
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],

            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            exId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            exWidth: "",
            DialogExtract: false,
            seType: "",
            smId: "",
            se: [],
            showStatus: false,
            actionData: [],
            multipleSelection: [],
            seTitle: "",
            seWidth: "",
            seId: "",
            DialogVisible: false,
            parentSearchData: {},
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.smId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 子组件触发
        drawerCancel() {
            this.showStatus = false;
            this.getDataList();
        },
        // 多选框
        handleSelectionChange(val) {
            console.log(val);
            this.multipleSelection = val;
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getExtractName(e) {
            console.log(e);
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.psomBuycus = dataInfo.smId;
                        this.getRequestData.smName = dataInfo.smName;
                    }
                    break;
            }
        },
        getStatusName(status) {
            const statusMap = {
                '-1': '审核驳回',
                '0': '初始',
                '1': '提交',
                '2': '审核通过',
                '3': '复核通过',
                '4': '验收完成',
                '5': '记账完成',
            };
            return statusMap[status] || '未知状态';
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                console.log(responseData.result);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.addBook()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        addBook() {
            if (this.multipleSelection.length > 0) {
                this.$confirm("是否批量入账?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(async () => {
                        let arrtemp = [];
                        this.multipleSelection.map((val) => {
                            arrtemp.push(val.rminToId);
                        });
                        var delData = {
                            ids: arrtemp,
                        };
                        //   this.showStatus = true;
                        let responseData = await this.$http.moveInBatchBke(delData);
                        console.log(responseData);
                        if (responseData.status == 200) {
                            this.$message.success(responseData.message);
                            this.$refs.orderKeepPrint.openBox(responseData.result)
                            this.getDataList();
                        } else {
                            this.$message.error(responseData.message);
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消批量入账",
                        });
                    });
            } else {
                this.$message({
                    message: "至少选择一条数据!",
                    type: "warning",
                });
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            if (this.getRequestData.smName == "") {
                this.getRequestData.smId = "";
            }
            let responseData = await this.$http.moveInBkeQueryTo(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
            // let responseData1 =  await this.$http.getPsAccountList(this.getRequestData)
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.psomId],
                    };
                    let responseData = await this.$http.delPurchaseOrder(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 提交审核
        submitDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("确定要提交审核?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.psomId],
                    };
                    let responseData = await this.$http.submitPurchaseOrder(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.getDataList();
        this.getButtonList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}
</style>